import React from 'react'
import DateHelper from "../../DateHelper/DateHelper"
import { addDays, parseISO } from 'date-fns';

export default class DetailsDateSection extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    
    var check_in_date = typeof this.props.reservation_segment.check_in_date == "string" ? parseISO(this.props.reservation_segment.check_in_date) : this.props.reservation_segment.check_in_date
    var check_out_date = typeof this.props.reservation_segment.check_in_date == "string" ? parseISO(this.props.reservation_segment.check_out_date) : this.props.reservation_segment.check_out_date

    return (
      <div className="date-selector row spacer">
        <div className="col-sm-6">
          <label>{I18n.t('arrival')}</label>
          <div>{DateHelper.printDateToScreen(check_in_date, this.props.date_format)}</div>
        </div>
        <div className="col-sm-6">
          <label>{I18n.t('departure')}</label>
          <span>{` (${this.props.reservation_segment.number_of_nights} ${this.props.reservation_segment.number_of_nights > 1 ? I18n.t('nights') : I18n.t('night')})`}</span>
          <div>{DateHelper.printDateToScreen(check_out_date, this.props.date_format)}</div>
        </div>
      </div> 
    );
  };

};